import {useMutation} from "@tanstack/react-query";
import {atomWithStorage} from "jotai/utils";
import {useAtom} from "jotai";
import { ToolApi } from "../util/ToolApi";

const AcceptedAtom = atomWithStorage("eula", false)

export function useAcceptEula(): [accepted: boolean, loading: boolean, accept: () => void] {
    const [accepted, setAccepted] = useAtom(AcceptedAtom)
    const acceptMutation = useMutation({
        mutationKey: ["accept-eula"],
        mutationFn: async () => {
            try {
                await ToolApi.post("accept-eula")
                setAccepted(true)
            } catch(e) {
                console.error("Failed to accept EULA", e)
                throw e
            }
        }
    })
    return [accepted, acceptMutation.isPending, () => acceptMutation.mutate()]
}